import { useEffect } from 'react'

import { UpdateStateHandler } from 'modules/url-state-storage/types'
import { QueueStatsFilterRequest, VolumeComparisonType } from 'types'

import { TicketsVolumeDetailsControls } from '../TicketsVolumeDetailsContext'
import { CalculateRangeUpdatesHandler } from '../types'

type VolumeEffectsParams = {
  updateState: UpdateStateHandler<TicketsVolumeDetailsControls>
  calculateRangeUpdates: CalculateRangeUpdatesHandler
  preparedFiltersForRequest: QueueStatsFilterRequest | undefined
}

export const useTicketsVolumeEffects = ({
  updateState,
  calculateRangeUpdates,
  preparedFiltersForRequest,
}: VolumeEffectsParams) => {
  useEffect(
    function recalculateInitialRangeParamsAfterTimeframeFilterIsChanged() {
      if (!preparedFiltersForRequest?.from && !preparedFiltersForRequest?.to) {
        return
      }

      updateState(previousState => {
        const newRange = calculateRangeUpdates({
          timeScale: previousState.timeScale,
          comparisonType: previousState.comparisonType,
        })
        const newComparisonType =
          previousState.comparisonType === VolumeComparisonType.Forecasts
            ? VolumeComparisonType.LastWeek
            : previousState.comparisonType

        return {
          comparisonType: newComparisonType,
          ...newRange,
        }
      })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [preparedFiltersForRequest?.from, preparedFiltersForRequest?.to],
  )

  useEffect(
    function resetForecastFiltersOnAdditionalFiltersApply() {
      if (!preparedFiltersForRequest) {
        return
      }

      updateState(previousState => {
        if (previousState.comparisonType !== VolumeComparisonType.Forecasts) {
          return undefined
        }

        const rangeUpdates = calculateRangeUpdates({
          timeScale: previousState.timeScale,
          comparisonType: VolumeComparisonType.LastWeek,
          forceSetFutureRange: false,
        })

        return {
          comparisonType: VolumeComparisonType.LastWeek,
          ...rangeUpdates,
        }
      })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [preparedFiltersForRequest],
  )
}
